import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';

var SocialButton = (_param)=> {
    var { onClick , socialProvider , caption , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick",
        "socialProvider",
        "caption",
        "className"
    ]);
    return React.createElement(Button, swcHelpers.extends({}, rest, {
        icon: `social-${socialProvider}`,
        size: "custom",
        variant: "barebones",
        onClick: onClick,
        className: classnames('social-button', `social-button--${socialProvider}`, className),
        caption: caption
    }));
};

export { SocialButton };
//# sourceMappingURL=SocialButton.js.map
